import { XIcon } from '@heroicons/react/solid';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

const ButtonExitModal = ({ text = "Cancel" }) => {
  return (
    <AlertDialog.Cancel asChild>
      <button
        className="absolute top-4 right-4 group flex items-center rounded-xl px-1 py-1 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-500 transition-all duration-300 ease-in-out"
        aria-label={`${text} and close dialog`}
      >
        <span className="flex items-center">
          <span
            className="whitespace-nowrap text-xs font-semibold text-red-700 opacity-0 max-w-0 overflow-hidden group-hover:mr-1 group-hover:opacity-100 group-hover:max-w-[4rem] transition-all duration-200 ease-in-out"
            aria-hidden="true"
          >
            {text}
          </span>
          <XIcon className="h-4 w-4 text-gray-500 group-hover:text-red-700" />
        </span>
      </button>
    </AlertDialog.Cancel>
  );
};

export default ButtonExitModal;